import { UPDATE_SELECTOR } from '../actions/types';
import { formValueSelector } from 'redux-form';

// Create base selector outside the reducer
export const defaultFormSelector = formValueSelector('default');

// Store current form name
let currentFormName = 'default';

// Export a function that returns the appropriate selector
export const getFormSelector = () => formValueSelector(currentFormName);

const initialState = {
  // Remove selector from state
  formName: 'default',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_SELECTOR:
      // Update the current form name in both module variable and state
      currentFormName = action.payload;
      return {
        ...state,
        formName: action.payload,
      };
    default:
      return state;
  }
}
